//
import request from "root/js/request";

const getPostingReturnDiagramReasonOzon = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  delivery_type,
  delivery_type__in,
}) => {
  const response = await request({
    url: "/ozon_analytics/posting_return/diagram/reason/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      delivery_type,
      delivery_type__in,
    },
  });
  return response.data;
};

export { getPostingReturnDiagramReasonOzon };
